import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Enlace corto del bot: /imagen?img=<token>&uid=<usuario> → abre el editor. */
export default function ImageEntry() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const img = params.get("img") || "";
    const uid = params.get("uid") || "";
    (async () => {
      try {
        const { data } = await axios.get(`${BACKEND}/api/editor/resolve`, { params: { img, uid } });
        navigate(`/editor/${data.job_id}?t=${data.token}`, { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "Esta imagen ya no está disponible");
      }
    })();
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center theme-noir px-6"
      style={{ backgroundColor: "#050507" }} data-testid="image-entry">
      {error ? (
        <div className="glass-card p-6 max-w-md text-center text-sm text-white/75" data-testid="image-entry-error">
          {error}
          <div className="text-[11px] text-white/45 mt-2">
            Vuelve a enviar tu foto al bot para recibir un enlace nuevo.
          </div>
        </div>
      ) : (
        <Loader2 className="w-8 h-8 animate-spin text-red-400" data-testid="image-entry-loading" />
      )}
    </div>
  );
}
